export default function () {
	return angular.element;
}
